import { Button } from "www/shared/components/buttons/Button";
import Container from "www/shared/components/container/Container";
import Image from "next/legacy/image";
import featuresExperience from "public/icons/check.svg";
import swirlyDoodle from "public/icons/swirly_doodle.svg";

const SponsorsContacts = () => {
  return (
    <section
      id="pricing"
      className="lg:h-screen flex items-center bg-slate-900 py-16 lg:py-28 bg-[url('/marketing/sponsors/contact/contact_bg.jpg')] bg-cover"
    >
      <Container className="flex flex-col lg:flex-row items-center lg:items-start lg:justify-between gap-12">
        <div className="max-w-[475px] text-center lg:text-left">
          <h2 className="relative">
            <div className="absolute left-1/2 -translate-x-1/2 -bottom-1 lg:left-0 lg:translate-x-0 lg:-bottom-4 w-[160px] lg:w-[281px] h-6 lg:h-10 fill-green-700 z-10">
              <Image src={swirlyDoodle} width={281} height={48} alt="" />
            </div>
            <span className="text-white block max-w-[340px] sm:max-w-[370px] lg:max-w-full m-auto text-3xl sm:text-4xl lg:text-5xl font-semibold relative z-20">
              A better experience. For everyone.
            </span>
          </h2>
          <p className="mt-6 text-gray-400 text-base lg:text-lg">
            Ready to take your investor relations to the next level? Contact us
            for a free demo.
          </p>
        </div>
        <Plan
          name="Full Deal Marketing Suite"
          description="Everything you need to launch deals, showcase your track record, and give your investors a great experience."
          features={[
            "Unlimited mass email functionality (including an easy to use drag-and-drop editor, and beautiful pre-built templates)",
            "Grow your network 4x faster with intuitive share & refer features",
            "ChatGPT-powered assistant",
            "Contacts management",
            "Secure deal room",
          ]}
        />
      </Container>
    </section>
  );
};

const Plan = ({
  name,
  description,
  features,
}: {
  name: string;
  description: string;
  features: string[];
}) => {
  return (
    <section className="w-[280px] lg:w-[344px] pt-6 lg:pt-10 p-4 lg:p-6 bg-gray-50 bg-opacity-10 text-white rounded-3xl border border-gray-300 backdrop-blur-[80px] flex flex-col justify-start items-start">
      <h3 className="text-lg font-medium">{name}</h3>
      <p className="mt-2 font-medium">{description}</p>
      <span className="text-xl lg:text-2xl font-semibold mt-6">
        Contact us for pricing
      </span>
      <ul role="list" className="mt-6 flex flex-col gap-y-3 text-sm">
        {features.map((feature) => (
          <li className="flex" key={feature}>
            <div className="flex-shrink-0 flex items-start">
              <Image src={featuresExperience} alt="" width={20} height={20} />
            </div>
            <span className="ml-4">{feature}</span>
          </li>
        ))}
      </ul>
      <Button variant="filledWhite" width="full" className="mt-8 font-semibold">
        Contact Us
      </Button>
    </section>
  );
};

export default SponsorsContacts;
